export default __webpack_public_path__ + "static/media/cal-female-condom.43b4db3e.jpg";